module.exports = __webpack_public_path__ + "img/o-sports.262bd93c.jpg";